'use strict';
import './styles/front.scss';

import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery.css';

document.addEventListener('DOMContentLoaded', function(){
    lightGallery(document.getElementById('lightgallery'), {
        selector: '.levit-flickr-album-image-container',
        speed: 500,
        thumbnail: true,
    });
});
